var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-item--time",attrs:{"id":_vm.id}},[_c('div',{staticClass:"content-wrap"},[_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }